import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Header from "../header/Header";

interface MainLayoutProps {
  children: ReactNode;
}

// Routes that should render full-screen without the header/shell
const FULL_SCREEN_ROUTES = ["/onboarding", "/login", "/signup", "/forgot-password", "/update-password"];

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const isFullScreen = FULL_SCREEN_ROUTES.some(r => pathname.startsWith(r));

  if (isFullScreen) {
    return <>{children}</>;
  }

  const isSelfManaged = pathname.startsWith("/settings");

  return (
    <div className="main-layout w-full h-screen flex flex-col">
      <Header />
      <main className={`flex-1 w-full ${isSelfManaged ? "overflow-hidden" : "overflow-y-auto bg-background/50"}`}>
        <div className={`w-full ${isSelfManaged ? "h-full" : ""}`}>{children}</div>
      </main>
    </div>
  );
};

export default MainLayout;
